import { Injectable } from '@angular/core';
import { SharedReplayRefresh } from '../ShareReplayRefresh';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  cache: Record<string, SharedReplayRefresh<any>> = {};

  constructor() { }

  save<T>(id: string, minutesToLive: number, source$: Observable<T>): Observable<T> {
    if (!Object.keys(this.cache).includes(id)) {
      this.cache[id] = new SharedReplayRefresh<any>(source$, minutesToLive);
    }

    return <unknown>this.cache[id].getSubscriber() as Observable<T>;
  }

  remove(id: string) {
    const idsToDelete = Object.keys(this.cache).reduce<string[]>((arr, key) => {
      if (key.includes(id)) {
        arr.push(key);
      }
      return arr;
    }, []);
    idsToDelete.map((idToDelete)=> {
      delete this.cache[idToDelete];
    });
  }

}
